module.exports = __webpack_public_path__ + "static/media/no_account.92f288c2.svg";